module.exports = __webpack_public_path__ + "static/media/analytics-white.83f862cc.svg";